import { Module } from 'vuex';
import { RootState } from '@/types/store';

declare global {
    interface ErrorInfo {
        type: 'icon';
        icon?: string;
        text?: string;
    }
}

export interface ErrorState {
    /** 错误技术 */
    errorCount: number;
    errorInfo: ErrorInfo | null;
}

const m: Module<ErrorState, RootState> = {
    namespaced: true,
    state: {
        errorCount: 0,
        errorInfo: null,
    },
    mutations: {
        /** 添加错误计数 */
        startError(state, info: ErrorInfo | null) {
            state.errorCount += 1;
            state.errorInfo = info;
        },
        /** 减少错误计数 */
        endError(state) {
            const count = state.errorCount;
            state.errorCount = Math.max(0, count - 1);
        },
    },
};

export default m;
